<template>
  <div >
    <ComponentLogin v-if="!isValid" @alLogearse="isValid = $event"/>
    <div v-if="isValid" >
      <RouterView/>
    </div>
  </div>
</template>
<script>

import  ComponentLogin  from '@/components/ComponentLogin.vue'
import {ValidarLogin} from '@/Apis/ApisUsuarios.js'

export default {
  components: {ComponentLogin},
  name: 'App',
  created(){
    ValidarLogin().then(
      response => this.isValid=response.valido 
    )
  },
  data: ()=> ({
    isValid: false
  })
}
</script>
<style scoped>
.todo{
  height: 100%;
  width: 100%;
}
</style>
